import React from "react";
import noBgLogo from "../../assets/logo/noBgColor_invert.png";

interface LogoProps {
  /** Optional CSS class for sizing/styling */
  className?: string;
  /** Alt text for accessibility */
  alt?: string;
}

const Logo: React.FC<LogoProps> = ({ className, alt = "Logo", ...props }) => (
  <img src={noBgLogo} alt={alt} className={className} {...props} />
);

export default Logo;
